import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

//首页
const Home = (resolve) => {
  import ('../page/Home').then((module) => {
    resolve(module)
  })
};

const Content = (resolve) => {
  import ('../page/Content').then((module) => {
    resolve(module)
  })
};

const CloudPark = (resolve) => {
  import ('../page/CloudPark').then((module) => {
    resolve(module)
  })
};

const Login = (resolve) => {
  import ('../page/Login').then((module) => {
    resolve(module)
  })
};

const AboutUs = (resolve) => {
  import ('../page/AboutUs').then((module) => {
    resolve(module)
  })
};

const Activities = (resolve) => {
  import ('../page/Activities').then((module) => {
    resolve(module)
  })
};

const Iframe = (resolve) => {
  import ('../page/Iframe').then((module) => {
    resolve(module)
  })
};

const PublicService = (resolve) => {
  import ('../page/ServiceContent').then((module) => {
    resolve(module)
  })
};


export default new Router({
  routes: [
    {path: "*", redirect: '/home'}, //路由重定向
    {path: '/home', name: 'home', component: Home, meta: {title: '首页'}},
    {path: '/content', name: 'content', component: Content},
    {path: '/cloudPark', name: 'cloudPark', component: CloudPark},
    {path: '/login', name: 'login', component: Login},
    {path: '/aboutUs', name: 'aboutUs', component: AboutUs},
    {path: '/activities', name: 'activities', component: Activities},
    {path: '/iframe', name: 'iframe', component: Iframe},
    {path: '/publicservice', name: 'publicservice', component: PublicService}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js